<template>
  <div>
    <el-row
      style="padding: 1%0%"
      class="flex align-content back-color-Bluebiack head"
    >
      <el-col :span="4" :offset="2"
        ><img src="../../assets/img/loge.png" style="height: 60px"
      /></el-col>
      <el-col :span="8" :offset="2">
        <div class="textherd">
          <!-- <el-menu
            :default-active="active"
            class="el-menu-demo"
            :router="true"
            mode="horizontal"
            @select="handleSelect"
            background-color="#054C84"
            text-color="#ffffff"
            active-text-color="red"

          >
            <el-submenu index="2">
              <template slot="title" style="font-size:20px" >运单管理</template>
              <el-menu-item index="/user/ordermanage">提单信息</el-menu-item>
            </el-submenu>
            <el-menu-item index="/user/companyinfor" style=""
             ref="fontColor" >公司组织</el-menu-item
            >
          </el-menu> -->
          <el-menu
  :default-active="this.$route.path"
  class="el-menu-demo"
  mode="horizontal"
  @select="handleSelect"
  background-color="#054C84"
  text-color="#fff"
 :router="true"
  active-text-color="#ffd04b">

  <el-submenu index="2">
    <template slot="title">运单管理</template>
    <el-menu-item index="/user/ordermanage">运单信息</el-menu-item>

  </el-submenu>

  <el-menu-item index="/user/companyinfor">公司组织</el-menu-item>
</el-menu>

        </div>
      </el-col>
      <el-col :span="4" :offset="3">
        <el-popover
          id="power"
          placement="top-start"
          width="150"
          trigger="hover"
          content="　　您是否要退出？"
        >
          <!-- <el-button slot="reference">hover 激活</el-button> -->
           <i class="el-icon-switch-button" @click="back" slot="reference"></i>
        </el-popover>

      </el-col>
    </el-row>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <span>确认要退出吗 ?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"
          class="cancel">取 消</el-button
        >
        <el-button @click="sure" class="bbt">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script >
import '@/assets/css/home.css'
import '@/assets/css/public.css'
export default {
  name: 'userheard',
  data () {
    return {
      dialogVisible: false,
      active: '2',
      activeIndex2: '2'
    }
  },
  methods: {

    back () {
      this.dialogVisible = true
    },
    sure () {
      this.dialogVisible = false
      this.$router.push('/log/login')
    },
    handleClose (done) {
      this.dialogVisible = false
    },
    handleSelect (index, keyPath) {
      // this.activeIndex2 = index
    }
  }
}
</script>

<style scoped>
.bbt{
  background: rgb(64,112,135);
  color: #fff;
  font-size:16px;
}
.head{
  height: 95px;
}
.el-menu-item {
  font-size: 18px;
}
.cancel{
  font-size:16px;
}
.el-submenu__title {
  font-size: 1.2rem;
}
>>>.el-dialog__body{
		font-size: 16px !important;
	}
.el-menu--popup {
  padding: 0px;
  box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.3);
}

.el-menu--horizontal {
  margin-left: 2%;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}

.el-menu--horizontal > .el-menu-item {
  border-bottom: none;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none;
}

.el-submenu.is-active .el-submenu__title {
  border-bottom: none;
}

i {
  font-size: 26px;
  color: #417188;
  margin-left: 238px;
}
.el-submenu >>> .el-submenu__title{
  font-size: 18px;
}

/deep/ .el-dialog__wrapper{
  top: 200px;

}
/deep/ .el-dialog__header{
  text-align: left;
}
/deep/ .el-dialog__body{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Userheard.vue